// Color intent system — one consistent meaning for color across every KPI and bar.
//   good    = on-track / healthy  (emerald)
//   warn    = worth attention     (amber)
//   bad     = needs action        (rose)
//   neutral = informational, no judgement (slate / foreground)
export const INTENT = {
  good:    { glow: "from-emerald-500/20 to-transparent", icon: "text-emerald-500", value: "text-emerald-500", chip: "text-emerald-500 border-emerald-500/30 bg-emerald-500/10" },
  warn:    { glow: "from-amber-500/20 to-transparent",   icon: "text-amber-500",   value: "text-amber-500",   chip: "text-amber-500 border-amber-500/30 bg-amber-500/10" },
  bad:     { glow: "from-rose-500/20 to-transparent",    icon: "text-rose-500",    value: "text-rose-500",    chip: "text-rose-500 border-rose-500/30 bg-rose-500/10" },
  neutral: { glow: "from-slate-400/10 to-transparent",   icon: "text-muted-foreground", value: "", chip: "text-muted-foreground border-border bg-accent" },
};

// Green gradient reserved for "progress toward a good goal" bars.
export const PROGRESS_BAR = "bg-gradient-to-r from-teal-400 to-emerald-500";

// Utilization keeps the same thresholds used across the app.
export const utilIntent = (u) => (u == null ? "neutral" : u < 30 ? "good" : u < 50 ? "warn" : "bad");
